// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchDataForBiddingConsolePage } from '../../../redux/modules/biddingConsole';
import { fetchLiveCatalogRegistrationIfNeeded } from '../../../redux/modules/catalogRegistration';
import { getIdFromPath } from '../../../utils/urls';
import { recordAnalyticsForBidConsolePageView } from '../../../redux/modules/analytics';

export default ({ location, store }: DataLoaderParams) => {
    const { pathname } = location;
    const { dispatch } = store;
    const catalogId = getIdFromPath(pathname);

    return Promise.all([
        dispatch(fetchDataForBiddingConsolePage(catalogId)),
        dispatch(fetchLiveCatalogRegistrationIfNeeded(catalogId)),
    ]).then(() => {
        return dispatch(recordAnalyticsForBidConsolePageView(catalogId));
    });
};
